module.exports = __webpack_public_path__ + "static/media/cafe_02.1aae73dd.png";